module.exports = __webpack_public_path__ + "static/agorize-thumbnail-dc310ff37513949a85ec56e6a5558d4c.png";